  <template>
  <article class="side_menu_group group1">

    
    <div class="grid-x">
    
        <div class="cell small-12">
            <legend class='t'>
                DISPLAY PREFERENCES
            </legend>
            <br>
        </div>

        <div class="cell small-12">
          <fieldset>
              <legend>
                  Results per page
              </legend>
                <div class="radio-toolbar">
                  <div class="radio-toolbar-group">
                    <input 
                      id="rpp1" 
                      v-model="resultsPerPage"
                      type="radio" 
                      name="results_per_page" 
                      :value="36"
                      @change="handleChangePerPage"
                      >
                    <label for="rpp1">
                      36
                    </label>
                  </div>
                  <div class="radio-toolbar-group">
                    <input 
                      id="rpp2" 
                      v-model="resultsPerPage"
                      type="radio" 
                      name="results_per_page" 
                      :value="60"
                      @change="handleChangePerPage"
                    > 
                      <label for="rpp2">
                        60
                      </label>
                  </div>
                  <div class="radio-toolbar-group">
                    <input 
                      id="rpp3" 
                      v-model="resultsPerPage"
                      type="radio" 
                      name="results_per_page" 
                      :value="120"
                      @change="handleChangePerPage"
                    >
                    <label for="rpp3">
                      120
                    </label>
                  </div>
                  <div class="radio-toolbar-group">
                    <input 
                      id="rpp4" 
                      v-model="resultsPerPage"
                      type="radio" 
                      name="results_per_page" 
                      :value="240"
                      @change="handleChangePerPage"
                    >
                    <label for="rpp4">
                      240
                    </label>
                  </div>
                </div>
              </fieldset>

        </div>

        <div class="cell small-12">
        
            <fieldset>
              <legend>
                  Grid Style
              </legend>

                <div class="radio-toolbar">
                  <div class="radio-toolbar-group">
                    <input 
                      id="grid_style1" 
                      v-model="gridStyle"
                      type="radio" 
                      name="grid_style" 
                      value="contained"
                      @change="handleChangegridStyle"
                      :checked="grid_style == null"

                    >
                    <label for="grid_style1">
                      Contain
                    </label>
                  </div>
                  <div class="radio-toolbar-group">
                    <input 
                      id="grid_style2" 
                      v-model="gridStyle"
                      type="radio" 
                      name="grid_style" 
                      value="isotope"
                      @change="handleChangegridStyle"
                    > 
                      <label for="grid_style2">
                        Masonry
                      </label>
                  </div>
                </div>
              </fieldset>
        
        </div>


        <div class="cell small-12">
        
            <fieldset>
              <legend>
                  Grid Size
              </legend>


            <div class="radio-toolbar">
              <div class="radio-toolbar-group">
                <input 
                  id="is1" 
                  v-model="imageSize"
                  type="radio" 
                  name="image_size" 
                  value="extra_small"
                  @change="handleChangeImageSize"
                >
                <label for="is1">
                  XS
                </label>
              </div>
              <div class="radio-toolbar-group">
                <input 
                  id="is2" 
                  v-model="imageSize"
                  type="radio" 
                  name="image_size" 
                  value="small"
                  @change="handleChangeImageSize"
                > 
                  <label for="is2">
                    S
                  </label>
              </div>
              <div class="radio-toolbar-group">
                <input 
                  id="is3" 
                  v-model="imageSize"
                  type="radio" 
                  name="image_size" 
                  value="medium"
                  @change="handleChangeImageSize"
                >
                <label for="is3">
                  M
                </label>
              </div>
              <div class="radio-toolbar-group">
                <input 
                  id="is4" 
                  v-model="imageSize"
                  type="radio" 
                  name="image_size" 
                  value="large"
                  @change="handleChangeImageSize"
                >
                <label for="is4">
                  L
                </label>
              </div>
            </div>
          </fieldset>
        </div>

        <div class="cell small-12">
        
            <fieldset>
              <legend>
                  On Hover
              </legend>
                <div class="checkbox-toolbar-group">
                  <input 
                    id="hover_symbols" 
                    v-model="hoverSymbols"
                    type="checkbox" 
                    name="hover_symbols" 
                    true-value="show"
                    false-value="hide"
                    @change="handleChangeHoverSymbols"
                  />
                  <label for="hover_symbols">
                      Show Quick Links
                  </label>
                </div>
            </fieldset>

        
        </div>

        <div class="cell small-12">
        
          <fieldset>
              <legend>On Click</legend>
              <div class="radio-toolbar">
                <div class="radio-toolbar-group">
                  <input
                    id="ac2" 
                    v-model="clickAction"
                    type="radio" 
                    name="click_action" 
                    value="details"
                    @change="handleChangeClickAction"
                  />
                  <label for="ac2">
                      Open
                  </label>
                </div>
                <div class="radio-toolbar-group">
                  <input
                    id="ac3" 
                    v-model="clickAction"
                    type="radio" 
                    name="click_action" 
                    value="lightbox"
                    @change="handleChangeClickAction"
                  />
                  <label for="ac3">
                      Add to Lightbox
                  </label>
                </div>
              </div>
          </fieldset>

        </div>

    </div>

  </article>
</template>
<script>
export default {
  name: 'CustomiseResults',
  props: {
    uiImageSize: String,
    uigridStyle: String,
    uiResultsPerPage: String,
    uiHoverMagnify: String,
    uiHoverSymbols: String,
    uiClickAction: String,
  },
  computed: {
    resultsPerPage: {
      get () {
        return this.$store.state.maxRecs;
      },
      set (value) {
        this.$store.state.maxRecs = value;
      },
    },
    imageSize: {
      get () {
        return this.$store.state.imageSize;
      },
      set (value) {
        this.$store.state.imageSize = value;
      },
    },
    gridStyle: {
      get () {
        return this.$store.state.gridStyle;
      },
      set (value) {
        this.$store.state.gridStyle = value;
      },
    },
    hoverMagnify: {
      get () {
        return this.$store.state.hoverMagnify;
      },
      set (value) {
        this.$store.state.hoverMagnify = value;
      },
    },
    hoverSymbols: {
      get () {
        return this.$store.state.hoverSymbols;
      },
      set (value) {
        this.$store.state.hoverSymbols = value;
      },
    },
    clickAction: {
      get () {
        return this.$store.state.clickAction;
      },
      set (value) {
        this.$store.state.clickAction = value;
      },
    },
  },
  created: function () {
    // console.log("CustomiseResults created");
    this.imageSize = this.uiImageSize;
    this.gridStyle = this.uigridStyle;
    this.resultsPerPage = this.uiResultsPerPage;
    this.hoverMagnify = this.uiHoverMagnify;
    this.hoverSymbols = this.uiHoverSymbols;
    this.clickAction = this.uiClickAction;
  },
  mounted: function () {

    // temp apply pro to result
    //  console.log(this);
    //  console.log('%c'+this.imageSize, 'background: #222; color: #bada55');
    //  console.log('%c'+this.gridStyle, 'background: #222; color: #bada55');
    //  console.log('%c'+this.resultsPerPage, 'background: #222; color: #bada55');
    //  console.log('%c'+this.hoverMagnify, 'background: #222; color: #bada55');
    //  console.log('%c'+this.hoverSymbols, 'background: #222; color: #bada55');
    //  console.log('%c'+this.clickAction, 'background: #222; color: #bada55');
    $('input:radio[name="results_per_page"]').filter('[value="'+this.resultsPerPage+'"]').prop('checked', true);
    // GRID LOCAL STORAGE FALLBACK START
    if(this.gridStyle != null){
      var $grid_style = this.gridStyle; 
    } else {
      var $grid_style = localStorage.getItem("milim_grid_style");
    }
    // GRID LOCAL STORAGE FALLBACK END

    // console.log($grid_style);
    if($grid_style=='isotope'){
      // console.log('set up as isotope');
      $('#grid_style2').prop('checked', true);
      $('#search_results').addClass('isotope');
      $('#search_results .item_container').eq(0).addClass('isotope-first');
      $('#search_results .flex-image').addClass('flex-isotope').removeClass('flex-image');
      $("#search_results img.lazy").each(function() {  
        $(this).attr('src', $(this).attr('data-original'));
      });  

      $('#search_results').masonry({
        columnWidth: '.isotope-first',
        percentPosition: true,
        itemSelector: '.item_container',
        transitionDuration: 0

      });
      $('#search_results').imagesLoaded().progress( function() {
        $('#search_results').masonry('layout');
      });

    } else {
      $('#grid_style1').prop('checked', true);
      // console.log('set up as contained');
      if ($('#search_results').data('masonry') !== undefined) {
        $('#search_results').masonry('destroy');
      }
      $('#search_results .flex-isotope').addClass('flex-image').removeClass('flex-isotope');
      $('#search_results').removeClass('isotope');
    }

  },

  methods: {
    handleChangeResultsPerPage() {
      // console.log("handleChangeResultsPerPage");
      console.log("CHANGING GRID");
      console.log(this.gridStyle);
      this.updateResultsPerPage();
      // console.log(this.updateResultsPerPage());
    },
    handleChangePerPage() {
      // console.log("handleChangePerPage");
      this.updateResultsPerPage();
    },
    handleChangeImageSize() {
      // console.log("handleChangeImageSize");
      search_results.update_image_size(this.imageSize);
      
      // if(this.gridStyle=='isotope'){
      //   $('#search_results').masonry().masonry('reloadItems');
      // }
      // console.log('laying out fix');
      // console.log(grid_style);
      if(grid_style=='isotope'){
        $('#search_results').masonry('layout');
      }

      window.dispatchEvent(new Event('resize')); // resize event triggers lazy load


      // TODO: update prefs
      // this.updateImageSize();
    },
    handleChangegridStyle() {
      // console.log(this.gridStyle);
      this.updategridStyle();
      // if(this.gridStyle!=null){
      //   localStorage.setItem('milim_grid_style', this.gridStyle); // fallback
      // }
      if(this.gridStyle=='isotope'){
        $('#search_results').addClass('isotope');
        $('#search_results .item_container').eq(0).addClass('isotope-first');
        $('#search_results .flex-image').addClass('flex-isotope').removeClass('flex-image');
        $('#search_results').masonry({
          columnWidth: '.isotope-first',
          percentPosition: true,
          itemSelector: '.item_container',
          transitionDuration: 0

        });
      } else {
        if ($('#search_results').data('masonry') !== undefined) {
          $('#search_results').masonry('destroy');
        }
        $('#search_results .flex-isotope').addClass('flex-image').removeClass('flex-isotope');
        $('#search_results').removeClass('isotope');
      }
      grid_style = this.gridStyle;
      this.updategridStyle();
      // GRID LOCAL STORAGE FALLBACK START
      if(this.gridStyle!=null){
        localStorage.setItem('milim_grid_style', this.gridStyle); // fallback
      }
      // GRID LOCAL STORAGE FALLBACK END
      //   grid_style = this.gridStyle;
      //   this.updategridStyle();
    },
    handleChangeHoverMagnify() {
      // console.log("handleChangeHoverMagnify");
      hover_magnify = this.hoverMagnify;
      this.updateHoverMagnify();
      if(hover_magnify!="show"){
          $('body').addClass('--hovermagnify');
      } else {
          $('body').removeClass('--hovermagnify');
      }


    },
    handleChangeHoverSymbols() {
      // console.log("handleChangeHoverSymbols");
      hover_symbols = this.hoverSymbols;
      this.updateHoverSymbols();
    },
    handleChangeClickAction() {
      // console.log("handleChangeClickAction");
      click_action = this.clickAction;
      this.updateClickAction();
    },
    updateResultsPerPage() {
      // console.log(window.baseUrl);
      const data = {
        action: "results_per_page", 
        value: this.resultsPerPage,
      };
      // console.log(this.resultsPerPage);
      this.axios.post(window.baseUrl + 'ajax', data).then(response => {
        // console.log(response.data.responseResult);
        window.location.reload();

      });
    },
    // updateImageSize() {
    //   // console.log(window.baseUrl);
    //   const data = {
    //     action: "image_size", 
    //     value: this.imageSize,
    //   };
    //   this.axios.post(window.baseUrl + 'ajax', data).then(response => {
    //     // console.log(response.data.responseResult);
    //   });
    // },
    updateHoverMagnify() {
      // console.log(window.baseUrl);
      const data = {
        action: "hover_magnify", 
        value: this.hoverMagnify,
      };

      this.axios.post(window.baseUrl + 'ajax', data).then(response => {
        // console.log(response.data.responseResult);
      });
    },
    updategridStyle() {
      // console.log(window.baseUrl);
      const data = {
        action: "grid_style",
        value: this.gridStyle,
      };

      this.axios.post(window.baseUrl + 'ajax', data).then(response => {
        // console.log(response.data.responseResult);
      });
    },    
    updateHoverSymbols() {
      // console.log(window.baseUrl);
      const data = {
        action: "hover_symbols", 
        value: this.hoverSymbols,
      };
      if(this.hoverSymbols=="show"){
          $('#search_results').addClass('--hoversymbols');
      } else {
          $('#search_results').removeClass('--hoversymbols');
      }
      this.axios.post(window.baseUrl + 'ajax', data).then(response => {
        // console.log(response.data.responseResult);
      });
    },
    updateClickAction() {
      // console.log(window.baseUrl);
      const data = {
        action: "click_action", 
        value: this.clickAction,
      };
      this.axios.post(window.baseUrl + 'ajax', data).then(response => {
        // console.log(response.data.responseResult);
      });
    },
  },
}
</script>
